import * as React from 'react';
import { makeid } from '../core/Const';
export function requestingHotels(jum: number) {
    let ret: any[] = [];
    for (let i = 0; i < jum; i++) {
        ret.push(
            <div  key={makeid()}  className={`col-md-12 row nopadding hotel-list`}>
                <div className="col-md-4 nopadding">
                    <div style={{ backgroundColor: '#ccc', minHeight: 200 }} />

                </div>
                <div className="col-md-8" style={{ margin: '10px 0', minHeight: 180 }} >
                    <p className="mobile-only" style={{textAlign: 'center'}}>Please wait 15 seconds while we search 1600 of Bali’s best hotels. <br/>
                    "Did you know Bali has the highest concentration of spas in the world!"   <br/>
                    You're going to love your Bali holiday <i className="fa fa-smile-o" /></p>
                    <div className='loader' />
                </div>
            </div>
        );
    }
    return ret;
}


// WEBPACK FOOTER //
// ./src/core/SmallComponent.tsx